import { render, staticRenderFns } from "./ApplicationDetail.vue?vue&type=template&id=659bd3ba&"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDetail.vue?vue&type=style&index=0&id=659bd3ba&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCol,VFlex,VIcon,VRow,VSnackbar,VTab,VTabItem,VTabs,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('659bd3ba')) {
      api.createRecord('659bd3ba', component.options)
    } else {
      api.reload('659bd3ba', component.options)
    }
    module.hot.accept("./ApplicationDetail.vue?vue&type=template&id=659bd3ba&", function () {
      api.rerender('659bd3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/approver/ApplicationDetail.vue"
export default component.exports